(function () {
    'use strict';

    angular.module("imApp").factory("productLinksService", ['$ihttp', function ($ihttp) {
        let service = {
            getProductLinks: function (parms) {
                return $ihttp.post({
                    method: 1827,
                    parameters: parms || {}
                });
            },
            listProductLinks: function (parms) {
                return $ihttp.post({
                    method: 1831,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
